var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper rtl public-shell",class:{ 'dashboard-shell client-dashboard-shell': _vm.isClientDashboardRoute }},[_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('div',{staticClass:"content"},[_c('fade-transition',{attrs:{"duration":100,"mode":"out-in"}},[_c('router-view')],1)],1),_c('content-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }